import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "referral-configuration",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const referralConfiguration =
            require("./ReferralConfiguration").default;
          cb(null, referralConfiguration);
        },
        "ReferralConfiguration"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/ReferralConfiguration/index.js